var Dlrt;
(function (Dlrt) {
    class GenericSearch {
        constructor(container, onChange) {
            this.container = container;
            this.onChange = onChange;
            this.clearButton = this.container.find('.js-generic-search-reset');
            this.searchButton = this.container.find('.js-generic-search-confirm');
            this.init();
        }
        get Value() {
            return this.input.val();
        }
        set Value(v) {
            this.input.val(v);
        }
        hasValue() {
            return !!this.Value;
        }
        clear() {
            this.Value = '';
            this.updateClearButton();
        }
        init() {
            this.input = this.container.find('input.delphi-generic-search-input');
            this.input.on('keyup', e => this.onKey(e));
            this.clearButton.click(() => this.onReset());
            this.searchButton.click(() => this.onSearch());
            this.updateClearButton();
        }
        onKey(e) {
            let key = (e.keyCode ? e.keyCode : e.which);
            if (key === 13) {
                this.onSearch();
            }
        }
        onReset() {
            this.clear();
            this.changed();
        }
        onSearch() {
            this.changed();
        }
        changed() {
            this.updateClearButton();
            if (this.onChange) {
                this.onChange(this.input.val());
            }
        }
        updateClearButton() {
            this.clearButton.toggleClass('hidden', !this.input.val());
        }
    }
    Dlrt.GenericSearch = GenericSearch;
})(Dlrt || (Dlrt = {}));
$.fn.makeGenericSearchBar = function (onChange) {
    return new Dlrt.GenericSearch(this, onChange);
};
$.fn.makeMultipleGenericSearchBars = function (onChange) {
    return this.toArray().map(e => $(e).makeGenericSearchBar(onChange));
};

//# sourceMappingURL=GenericSearch.js.map
